import React from 'react';
import './TemplateFieldEditor.css';

const FIELD_TYPES = ['string', 'number', 'boolean', 'date', 'list', 'object'];

// 개별 필드 편집기
// field: TemplateField (draft)
// onChange: (updatedField) => void
// onRemove: () => void
// depth: 중첩 깊이 (0=최상위, 1=object 하위)
const TemplateFieldEditor = ({ field, onChange, onRemove, depth = 0 }) => {
  const update = (key, value) => onChange({ ...field, [key]: value });

  // object 하위 필드 변경
  const updateSubField = (index, updated) => {
    const subFields = [...(field.fields || [])];
    subFields[index] = updated;
    update('fields', subFields);
  };

  const addSubField = () => {
    update('fields', [
      ...(field.fields || []),
      { key: '', label: '', type: 'string', required: false }
    ]);
  };

  const removeSubField = (index) => {
    update('fields', (field.fields || []).filter((_, i) => i !== index));
  };

  return (
    <div className={`tfe-container depth-${depth}`}>
      <div className="tfe-header">
        <span className="tfe-drag-handle">≡</span>
        <select
          className="tfe-select"
          value={field.type || 'string'}
          onChange={(e) => update('type', e.target.value)}
        >
          {FIELD_TYPES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
        <input
          type="text"
          className="tfe-input tfe-key"
          placeholder="key"
          value={field.key || ''}
          onChange={(e) => onChange({ ...field, key: e.target.value, label: e.target.value })}
        />
        <button
          type="button"
          className="tfe-remove-btn"
          onClick={onRemove}
          aria-label="필드 삭제"
        >
          ✕
        </button>
      </div>

      <div className="tfe-options">
        {/* 공통: required */}
        {field.type !== 'boolean' && (
          <label className="tfe-checkbox-label">
            <input
              type="checkbox"
              checked={!!field.required}
              onChange={(e) => update('required', e.target.checked)}
            />
            <span>필수</span>
          </label>
        )}

        {/* number: min, max */}
        {field.type === 'number' && (
          <>
            <div className="tfe-option-group">
              <label className="tfe-option-label">최소값</label>
              <input
                type="number"
                className="tfe-input tfe-small"
                placeholder="최소"
                value={field.min ?? ''}
                onChange={(e) => update('min', e.target.value === '' ? undefined : Number(e.target.value))}
              />
            </div>
            <div className="tfe-option-group">
              <label className="tfe-option-label">최대값</label>
              <input
                type="number"
                className="tfe-input tfe-small"
                placeholder="최대"
                value={field.max ?? ''}
                onChange={(e) => update('max', e.target.value === '' ? undefined : Number(e.target.value))}
              />
            </div>
          </>
        )}

        {/* boolean: default */}
        {field.type === 'boolean' && (
          <label className="tfe-checkbox-label">
            <input
              type="checkbox"
              checked={!!field.default}
              onChange={(e) => update('default', e.target.checked)}
            />
            <span>기본값: 체크</span>
          </label>
        )}

        {/* list: item_type */}
        {field.type === 'list' && (
          <div className="tfe-option-group">
            <label className="tfe-option-label">항목 타입</label>
            <select
              className="tfe-select tfe-small"
              value={field.item_type || 'string'}
              onChange={(e) => update('item_type', e.target.value)}
            >
              <option value="string">string</option>
              <option value="number">number</option>
            </select>
          </div>
        )}
      </div>

      {/* object: 하위 필드 */}
      {field.type === 'object' && depth < 1 && (
        <div className="tfe-subfields">
          <div className="tfe-subfields-title">하위 필드</div>
          {(field.fields || []).map((subField, i) => (
            <TemplateFieldEditor
              key={i}
              field={subField}
              onChange={(updated) => updateSubField(i, updated)}
              onRemove={() => removeSubField(i)}
              depth={depth + 1}
            />
          ))}
          <button
            type="button"
            className="tfe-add-sub-btn"
            onClick={addSubField}
          >
            + 하위 필드 추가
          </button>
        </div>
      )}
    </div>
  );
};

export default TemplateFieldEditor;
